<template>
    <div class="book-pdf-container pdf-container">
        <div class="view-container">
            <div class="loading-container" v-show="loading">
                <Loading-item></Loading-item>
            </div>
            <div class="pdf-page" ref="pdf">
                <pdf
                    :src="files"
                    v-if="currentPage"
                    :page="currentPage"
                    :text="false"
                    @loading="loaded"
                ></pdf>
            </div>
        </div>
        <div class="action-group">
            <img
                src="https://custouch-cloud.oss-cn-hangzhou.aliyuncs.com/cus_files/custouch/site/image/%E7%AE%AD%E5%A4%B4.png"
                class="button left"
                @click="slideTo(-1)"
            />
            <div class="center" v-if="total">
                &lt;{{ currentPage }}/{{ total }}&gt;
            </div>
            <div class="center" v-else>
                Loading...
            </div>
            <img
                src="https://custouch-cloud.oss-cn-hangzhou.aliyuncs.com/cus_files/custouch/site/image/%E7%AE%AD%E5%A4%B4.png"
                class="button right"
                @click="slideTo(1)"
            />
        </div>
    </div>
</template>
<script>
import pdf from './Pdfvuer'
import LoadingItem from './LoadingItem'
import gesture from './mixins/gesture'
export default {
    mixins: [gesture],
    props: {
        maxPage: {
            type: Number,
            default: null
        },
        pdfUrl: {}
    },
    data() {
        return {
            loading: true,
            files: {},
            total: 0,
            currentPage: 0
        }
    },
    components: {
        pdf,
        LoadingItem
    },
    mounted() {
        if (this.pdfUrl) {
            this.files = pdf.createLoadingTask({
                url: this.pdfUrl,
                cMapUrl:
                    'https://oss.cloud.custouch.com/static/cloud/font/cmaps/',
                cMapPacked: true
            })
            this.files
                .then(pdf => {
                    this.total = pdf.numPages
                    this.currentPage = 1
                    this.bindEvent()
                    // 移除动画
                    this.$emit('load', { total: this.total })
                    this.el.addEventListener('animationend', this.removeAnimate)
                })
                .catch(err => {
                    this.$emit('error', err.message)
                })
        }
    },
    computed: {
        el() {
            return this.$refs.pdf
        }
    },
    methods: {
        removeAnimate() {
            this.el.className = 'pdf-page'
        },
        slideTo(index) {
            this.$nextTick(() => {
                let target = this.currentPage + index,
                    showMask = true
                if (target > this.total) {
                    target = this.total
                    showMask = false
                } else if (target < 1) {
                    target = 1
                    showMask = false
                }
                if (showMask) {
                    if (index > 0) {
                        this.$refs.pdf.classList.add('moveNext')
                    } else {
                        this.$refs.pdf.classList.add('movePrev')
                    }
                }
                this.ResetPdfStyle()
                if (this.maxPage && target > this.maxPage) {
                    this.$emit('maxEnd')
                } else {
                    this.currentPage = target
                }
            })
        },
        loaded(loading) {
            this.loading = loading
        }
    }
}
</script>

<style scoped lang="less">
.movePrev {
    animation: maskMovePrev 0.5s ease-in;
}
.moveNext {
    animation: maskMoveNext 0.5s ease-in;
}
.pdf-page {
    width: 100%;
}
@keyframes maskMovePrev {
    .circle(100);
    .circle(@n, @i:0) when (@i <= @n) {
        @j: @i + 5;
        @selector: e(
            '@{i}%'
        ); // 使用 less e 函数变为选择器,注意！！直接套用或者使用 percentage 函数无法识别
        @{selector} {
            mask: linear-gradient(
                60deg,
                #000 e('@{i}%'),
                transparent e('@{j}%'),
                transparent 1%
            );
        }
        .circle(@n, (@i + 1));
    }
}
@keyframes maskMoveNext {
    .circle(100);
    .circle(@n, @i:0) when (@i <= @n) {
        @j: @i + 5;
        @selector: e(
            '@{i}%'
        ); // 使用 less e 函数变为选择器,注意！！直接套用或者使用 percentage 函数无法识别
        @{selector} {
            mask: linear-gradient(
                -60deg,
                #000 e('@{i}%'),
                transparent e('@{j}%'),
                transparent 1%
            );
        }
        .circle(@n, (@i + 1));
    }
}
</style>
<style lang="less">
.book-pdf-container {
    .canvasWrapper {
        box-shadow: 2px 4px 6px #ccc;
    }
}
</style>
